// Hamburger toggle for the mobile nav panel — desktop ignores this entirely
// (the burger button and the collapse behavior are both CSS-gated to narrow
// viewports; on desktop .site-header__nav is just always visible inline).
(function () {
  var burger = document.querySelector('.nav-burger');
  var nav = document.getElementById('SiteNav');
  if (!burger || !nav) return;

  burger.addEventListener('click', function () {
    var open = nav.classList.toggle('site-header__nav--open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // close the panel if the viewport grows back to desktop while it's open
  window.addEventListener('resize', function () {
    if (window.innerWidth > 768 && nav.classList.contains('site-header__nav--open')) {
      nav.classList.remove('site-header__nav--open');
      burger.setAttribute('aria-expanded', 'false');
    }
  });
})();
